module.exports = __webpack_public_path__ + "img/photo9.f58b28bb.jpg";